import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";
import type { ISessionFormApiPayload } from "../../types/form.type";

export type IGetSessionFormResponse = IResponse<ISessionFormApiPayload>;

export async function getSessionForm(params: {
	session_id: string;
	user_id: string;
}): Promise<IGetSessionFormResponse> {
	return await apiRequest<ISessionFormApiPayload>({
		path: `/api/session/${params.session_id}/form?user_id=${params.user_id.toString()}`,
		method: "GET",
	});
}
